// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1zr9k","error":"Textarea_error__ttwUu","readonly":"Textarea_readonly__2hXtA","disabled":"Textarea_disabled__3fa0z"};